<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getLandingPageTable(1)">
          <input-search
            :model="search" @update="searchInput"/>
        </div>
        <circle-button
          v-if="permissionLandingPage && permissionLandingPage.permission_id === permission.readWrite"
          @click.native="createLandingPageData"/>
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center" v-for="header in headers" :key="header.id">
              {{ header.text }}
              <template v-if="header.icon">
                <a @click="sortDataTable(header.id)">
                  <v-icon class="fas fa-caret-down"
                          v-if="sort == 'desc'"
                          style="font-size: 12px"></v-icon>
                  <v-icon class="fas fa-caret-up"
                          v-if="sort == 'asc'"
                          style="font-size: 12px"></v-icon>
                </a>
              </template>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(data,index) in dataTable" :key="data.id">
            <td>{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
            <td>{{data.title}}</td>
            <td>{{data.start_date | moment('DD-MM-YYYY')}}</td>
            <td>{{data.end_date | moment('DD-MM-YYYY')}}</td>
            <td>
              <a @click="showLandingPageData(data.id)">
                <icon-pencil/>
              </a>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
  import IconPencil from "../../components/Icon/icon-pencil";
  import CircleButton from "../../components/Button/CircleButton";
  import InputSearch from "../../components/Input/InputSearch";
  import Paginate from "../../components/Layout/Paginate";
  import {permissionLandingPage, role} from "../../util/Permission";
  import {mapState} from "vuex";
  import Swal from 'sweetalert';
  import Loading from 'vue-loading-overlay';
  export default {
    name: "LandingPageCategoryTable",
    components: {Paginate, InputSearch, CircleButton, IconPencil, Loading},
    data() {
      return {
        title: "Landing Page",
        isLoading: false,
        headers: [
          { id: 1, text: "No." ,icon : null},
          { id: 2, text: "Role name" ,icon : null},
          { id: 33, text: "Start date" ,icon : true},
          { id: 44, text: "End date" ,icon : null},
          { id: 5, text: "Edit" ,icon : null},
        ],
        dataTable: [],
        dataPaginate: {
          current_page: 1,
          from: 1,
          last_page: 1,
          per_page: 1,
          total: 1,
          to: 1
        },
        permission : null,
        search : '',
        sort_start : null,
        sort : 'desc',
      };
    },
    created() {
      this.permission = role;
      this.getLandingPageTable(1);
    },
    computed: {
      permissionLandingPage,
    },
    methods:{
      getLandingPageTable(page){
        this.isLoading = true;
        this.$store.dispatch("LandingPage/getLandingPage",{
          page,
          search : this.search,
          sort_start : this.sort_start,
        }).then(res=>{
          if(res.response_code == 200){
            this.dataTable = res.result.data;
          }else{
            Swal(res.response_msg)
          }
          this.isLoading = false;
        }).catch(()=>{
          Swal('','Cannot get Landing page data','error');
          this.isLoading = false;
        })
      },
      async changePage(val){
        this.isLoading = true;
        this.dataPaginate.current_page = val;
        await this.getLandingPageTable(this.dataPaginate.current_page);
        this.isLoading = false;
      },
      goToLandingPageEdit(){
        this.$router.push("/landing-page/edit");
      },
      showLandingPageData(id){
        this.isLoading = true;
        this.$store.dispatch("LandingPage/showLandingPage",id).then(res=>{
          if(res.response_code == 200){
            this.$store.dispatch("LandingPage/setFormLandingPage",res.result).then(()=>{
              this.goToLandingPageEdit();
            })
          }
          this.isLoading = false;
        }).catch(()=>{
          Swal('','Cannot get Landing page data','error');
          this.isLoading = false;
        });
      },
      createLandingPageData(){
        this.$store.dispatch("LandingPage/clearFormData").then(()=>{
          this.goToLandingPageEdit();
        });
      },
      searchInput(val){
        this.search = val;
      },
      sortDataTable(header_id){
        this.sort = this.sort == 'desc' ? 'asc' : 'desc';
        if(header_id === 33){ //sort by branch
          this.sort_start = this.sort_start == 'desc' ? 'asc' : 'desc';
        }
        this.getLandingPageTable(1);
      }
    }
  }
</script>

<style scoped>
  .branch-data {
    background-color: transparent;
    margin: 20px;
  }
</style>
